import { render, staticRenderFns } from "./settings-page.vue?vue&type=template&id=de880466&scoped=true&"
import script from "./settings-page.vue?vue&type=script&lang=js&"
export * from "./settings-page.vue?vue&type=script&lang=js&"
import style0 from "./settings-page.vue?vue&type=style&index=0&id=de880466&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de880466",
  null
  
)

export default component.exports